import { Button, Result } from 'antd';
import { useEffect, useRef } from 'react';
import { Route, Routes } from 'react-router-dom';
import {
  ActiveSessionProvider,
  ActiveSessionShell,
  useActiveSession,
} from '../api/active/sessionProvider';
import { AppProviders } from './AppProviders';
import { QuotationSystemRoot } from './QuotationSystemRoot';
import { CPQ_SHELL_BASE_PATH } from './runtimePaths';

const WECOM_LOGIN_POPUP_MARKER = 'cpq:wecom-login-popup:v1';
const WECOM_LOGIN_POPUP_MARKER_TTL_MS = 10 * 60 * 1000;

function hasRecentWeComLoginPopupMarker(): boolean {
  try {
    const value = window.sessionStorage.getItem(WECOM_LOGIN_POPUP_MARKER);
    if (!value || !/^\d+$/.test(value)) return false;
    const timestamp = Number(value);
    const age = Date.now() - timestamp;
    if (
      !Number.isFinite(timestamp) ||
      age < 0 ||
      age > WECOM_LOGIN_POPUP_MARKER_TTL_MS
    )
      return false;
    return true;
  } catch {
    return false;
  }
}

function CandidateRouteUnavailable() {
  return (
    <Result
      status="404"
      title="CPQ 未开放此路由"
      subTitle="该 deep-link 不属于当前已开放的 CPQ 路由。"
      extra={
        <Button href={CPQ_SHELL_BASE_PATH} type="primary">
          返回 CPQ 首页
        </Button>
      }
    />
  );
}

function QuotationSystemRoute() {
  return <QuotationSystemRoot />;
}

function WeComLoginPopupSession() {
  const { state } = useActiveSession();
  const callbackPresent = useRef(
    (() => {
      const parameters = new URLSearchParams(window.location.search);
      return Boolean(parameters.get('code') && parameters.get('state'));
    })(),
  ).current;

  useEffect(() => {
    if (callbackPresent && state.status === 'ready') {
      try {
        window.close();
      } catch {
        // A browser may refuse to close a window it did not open itself.
      }
    }
  }, [callbackPresent, state.status]);

  return <ActiveSessionShell wecomLoginEnabled />;
}

function WeComCallbackRoute() {
  if (!hasRecentWeComLoginPopupMarker()) return <QuotationSystemRoute />;
  return (
    <ActiveSessionProvider>
      <WeComLoginPopupSession />
    </ActiveSessionProvider>
  );
}

export function ViteCpqShell() {
  return (
    <AppProviders>
      <Routes>
        <Route index element={<QuotationSystemRoute />} />
        <Route path="auth/wecom/return" element={<WeComCallbackRoute />} />
        <Route path="*" element={<CandidateRouteUnavailable />} />
      </Routes>
    </AppProviders>
  );
}
